import { render, staticRenderFns } from "./opsgenie.vue?vue&type=template&id=157688b0&scoped=true&"
import script from "./opsgenie.vue?vue&type=script&lang=js&"
export * from "./opsgenie.vue?vue&type=script&lang=js&"
import style0 from "./opsgenie.vue?vue&type=style&index=0&id=157688b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157688b0",
  null
  
)

export default component.exports